const toServerOptIns = (optIns) => {
  if (!optIns) {
    return { optinValues: {} };
  }
  return optIns.reduce(
    (result, optIn) => ({
      optinValues: {
        ...result.optinValues,
        [optIn.id]: optIn.value ?? false
      }
    }),
    { optinValues: {} }
  );
};
export {
  toServerOptIns
};
//# sourceMappingURL=opt-ins-server.js.map
